import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDesktop = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: "24px",
	viewBox: "0 -960 960 960",
	width: "24px",
	fill: "#000000",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M340-140v-60h80v-80H172.31Q142-280 121-301q-21-21-21-51.31v-395.38Q100-778 121-799q21-21 51.31-21h615.38Q818-820 839-799q21 21 21 51.31v395.38Q860-322 839-301q-21 21-51.31 21H540v80h80v60H340ZM172.31-340h615.38q4.62 0 8.46-3.84 3.85-3.85 3.85-8.47v-395.38q0-4.62-3.85-8.46-3.84-3.85-8.46-3.85H172.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46v395.38q0 4.62 3.85 8.47 3.84 3.84 8.46 3.84ZM160-340v-420 420Z" })
});
export default SvgDesktop;
